import "./product.js";
import "../../shared/images/avatar-default.png";
import "../../shared/images/angel-host.png";
import "./verify-box.njk";
require("./product.less");